import React from "react";
import "../styles/LinksInfo.css";

type Store = {
  name: string;
  url: string;
};

const stores: Store[] = [
  {
    name: "MercadoLibre",
    url: "https://articulo.mercadolibre.cl/MLC-2362703948-shaker-electricoautomatico-premium-650mlgymgimnasio-_JM#origin%3Dshare%26sid%3Dshare"
  },
  {
    name: "Falabella",
    url: "https://www.falabella.com/falabella-cl/search?Ntt=shaker%20electrico"
  },
  {
    name: "Paris",
    url: "https://www.paris.cl/shaker-premium-electrico-650-ml-MKSXDL6GPR.html"
  },
  {
    name: "Pagina Propia",
    url: "https://www.prodnook.cl" // ajusta a tu dominio real
  }
];

const LinksInfo: React.FC = () => {
  return (
    <main className="dondec-container">
      <section className="dondec-content">
        <h2 className="dondec-title">¿Dónde compro?</h2>

        <div className="dondec-list">
          {stores.map((store, index) => (
            <a
              key={index}
              href={store.url}
              target="_blank"
              rel="noopener noreferrer"
              className="dondec-item"
            >
              {store.name}
            </a>
          ))}
        </div>
      </section>
    </main>
  );
};

export default LinksInfo;
